function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(Path, {
  d: "M.602 0a.627.627 0 00-.581.785L2.104 8.59l9.195 1.408-9.194 1.406-2.084 7.807a.625.625 0 00.885.72l18.75-9.374a.627.627 0 000-1.117L.906.065A.613.613 0 00.602.001z",
  fill: "#5B41F0",
  fillRule: "nonzero"
});

function SvgIconSendMessage(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _ref);
}

export default SvgIconSendMessage;